<template>
  <mdb-row class="my-5">
    <mdb-col class="mx-auto" md="6">
      <card title="로그인" icon="sign-in-alt">
        <div  class="px-4">
        <form>
          <mdb-input label="사용자 ID" name="userId" v-model="user.userId" icon="user"/>
          <mdb-input label="비밀번호" name="password" type="password" v-model="user.password" icon="lock"/>
          <div class="red-text mb-3 ml-4" v-if="error"><mdb-icon  icon="exclamation-triangle" /> {{error}}</div>
          <div class="text-center">
            <div>
              <mdb-btn icon="sign-in-alt" @click="onLogin" style="width:100%">로그인</mdb-btn>
            </div>
            <div>
              <mdb-btn icon="sign-in-alt" @click="$router.push({name: 'JoinOrg'})" style="width:100%">회원가입</mdb-btn>
            </div>
          </div>
        </form>
        </div>
      </card>
    </mdb-col>
  </mdb-row>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
import { LOGIN } from '@/store/modules/auth/AuthType'
import Card from '../../components/common/Card.vue';
export default {
  name: 'LoginPage',
  components: { Card },
  data: () => ({
    user: {
      userId: '',
      password: ''
      // '01042553236', // 'dbrlwlf', // 'admin@ksica.or.kr', // 'test', '01042553236',   , hpe@hpe.com
      // userId: 'admin@ksica.or.kr',
      // password: 'skku9054'
    },
    error: ''
  }),
  computed: {
    ...mapState('auth', ['test'])
  },
  methods: {
    ...mapActions('auth', [LOGIN]),
    async onLogin () {
      try {
        // 로그인 성공시
        const { profile, training } = await this.login(this.user)
        this.error = '사용자 ID 또는 비밀번호가 올바르지 않습니다.'
        this.$router.push({ name: 'Home' });
      } catch (e) {
        this.error = '사용자 ID 또는 비밀번호가 올바르지 않습니다.'
        console.log('로그인 실패----', e)
      }
    }
  }
}
</script>
